var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8285_800385)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    width: 20,
    height: 15,
    rx: 1.66667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666504 0.5H20.6665V15.5H0.666504V0.5Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666504 9.67188V10.9219H20.6665V9.67188H0.666504Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666504 11.9609V13.2109H20.6665V11.9609H0.666504Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666504 5.08594V6.33594H20.6665V5.08594H0.666504Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666504 14.25V15.5H20.6665V14.25H0.666504Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666504 7.375V8.625H20.6665V7.375H0.666504Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666504 0.5V1.75H20.6665V0.5H0.666504Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666504 2.79688V4.04688H20.6665V2.79688H0.666504Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    y: 0.5,
    width: 12.5,
    height: 8.125,
    fill: "#2E42A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.74252 2.342L1.28884 2.66006L1.44201 2.09405L1.03906 1.73535H1.56537L1.74189 1.27344L1.94887 1.73535H2.39753L2.045 2.09405L2.18148 2.66006L1.74252 2.342ZM4.24252 2.342L3.78884 2.66006L3.94201 2.09405L3.53906 1.73535H4.06537L4.24189 1.27344L4.44887 1.73535H4.89753L4.545 2.09405L4.68148 2.66006L4.24252 2.342ZM6.28884 2.66006L6.74252 2.342L7.18148 2.66006L7.045 2.09405L7.39753 1.73535H6.94887L6.74189 1.27344L6.56537 1.73535H6.03906L6.44201 2.09405L6.28884 2.66006ZM9.24252 2.342L8.78884 2.66006L8.94201 2.09405L8.53906 1.73535H9.06537L9.24189 1.27344L9.44887 1.73535H9.89753L9.545 2.09405L9.68148 2.66006L9.24252 2.342ZM1.28884 5.16006L1.74252 4.842L2.18148 5.16006L2.045 4.59405L2.39753 4.23535H1.94887L1.74189 3.77344L1.56537 4.23535H1.03906L1.44201 4.59405L1.28884 5.16006ZM4.24252 4.842L3.78884 5.16006L3.94201 4.59405L3.53906 4.23535H4.06537L4.24189 3.77344L4.44887 4.23535H4.89753L4.545 4.59405L4.68148 5.16006L4.24252 4.842ZM6.28884 5.16006L6.74252 4.842L7.18148 5.16006L7.045 4.59405L7.39753 4.23535H6.94887L6.74189 3.77344L6.56537 4.23535H6.03906L6.44201 4.59405L6.28884 5.16006ZM9.24252 4.842L8.78884 5.16006L8.94201 4.59405L8.53906 4.23535H9.06537L9.24189 3.77344L9.44887 4.23535H9.89753L9.545 4.59405L9.68148 5.16006L9.24252 4.842ZM1.28884 7.66006L1.74252 7.342L2.18148 7.66006L2.045 7.09405L2.39753 6.73535H1.94887L1.74189 6.27344L1.56537 6.73535H1.03906L1.44201 7.09405L1.28884 7.66006ZM4.24252 7.342L3.78884 7.66006L3.94201 7.09405L3.53906 6.73535H4.06537L4.24189 6.27344L4.44887 6.73535H4.89753L4.545 7.09405L4.68148 7.66006L4.24252 7.342ZM6.28884 7.66006L6.74252 7.342L7.18148 7.66006L7.045 7.09405L7.39753 6.73535H6.94887L6.74189 6.27344L6.56537 6.73535H6.03906L6.44201 7.09405L6.28884 7.66006ZM9.24252 7.342L8.78884 7.66006L8.94201 7.09405L8.53906 6.73535H9.06537L9.24189 6.27344L9.44887 6.73535H9.89753L9.545 7.09405L9.68148 7.66006L9.24252 7.342ZM11.2888 2.66006L11.7425 2.342L12.1815 2.66006L12.045 2.09405L12.3975 1.73535H11.9489L11.7419 1.27344L11.5654 1.73535H11.0391L11.442 2.09405L11.2888 2.66006ZM11.7425 4.842L11.2888 5.16006L11.442 4.59405L11.0391 4.23535H11.5654L11.7419 3.77344L11.9489 4.23535H12.3975L12.045 4.59405L12.1815 5.16006L11.7425 4.842ZM11.2888 7.66006L11.7425 7.342L12.1815 7.66006L12.045 7.09405L12.3975 6.73535H11.9489L11.7419 6.27344L11.5654 6.73535H11.0391L11.442 7.09405L11.2888 7.66006ZM2.99252 3.592L2.53884 3.91006L2.69201 3.34405L2.28906 2.98535H2.81537L2.99189 2.52344L3.19887 2.98535H3.64753L3.295 3.34405L3.43148 3.91006L2.99252 3.592ZM5.03884 3.91006L5.49252 3.592L5.93148 3.91006L5.795 3.34405L6.14753 2.98535H5.69887L5.49189 2.52344L5.31537 2.98535H4.78906L5.19201 3.34405L5.03884 3.91006ZM7.99252 3.592L7.53884 3.91006L7.69201 3.34405L7.28906 2.98535H7.81537L7.99189 2.52344L8.19887 2.98535H8.64753L8.295 3.34405L8.43148 3.91006L7.99252 3.592ZM2.53884 6.41006L2.99252 6.092L3.43148 6.41006L3.295 5.84405L3.64753 5.48535H3.19887L2.99189 5.02344L2.81537 5.48535H2.28906L2.69201 5.84405L2.53884 6.41006ZM5.49252 6.092L5.03884 6.41006L5.19201 5.84405L4.78906 5.48535H5.31537L5.49189 5.02344L5.69887 5.48535H6.14753L5.795 5.84405L5.93148 6.41006L5.49252 6.092ZM7.53884 6.41006L7.99252 6.092L8.43148 6.41006L8.295 5.84405L8.64753 5.48535H8.19887L7.99189 5.02344L7.81537 5.48535H7.28906L7.69201 5.84405L7.53884 6.41006ZM10.4925 3.592L10.0388 3.91006L10.192 3.34405L9.78906 2.98535H10.3154L10.4919 2.52344L10.6989 2.98535H11.1475L10.795 3.34405L10.9315 3.91006L10.4925 3.592ZM10.0388 6.41006L10.4925 6.092L10.9315 6.41006L10.795 5.84405L11.1475 5.48535H10.6989L10.4919 5.02344L10.3154 5.48535H9.78906L10.192 5.84405L10.0388 6.41006Z",
    fill: "#F7FCFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8285_800385"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    width: 20,
    height: 15,
    rx: 1.66667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsIcon);
export default __webpack_public_path__ + "static/media/us-icon.d091fc56a5f7f399926fa5b2f4b3ad34.svg";
export { ForwardRef as ReactComponent };